export const HIDE_RELOGIN_DIALOG = 'HIDE_RELOGIN_DIALOG';
export const SET_RELOGIN_DIALOG_LOADING = 'SET_RELOGIN_DIALOG_LOADING';
export const SET_RELOGIN_DIALOG_LOADED = 'SET_RELOGIN_DIALOG_LOADED';
export const SHOW_RELOGIN_DIALOG = 'SHOW_RELOGIN_DIALOG';

export const hideReloginDialog = () => ({
  type: HIDE_RELOGIN_DIALOG,
});

export const showReloginDialog = () => ({
  type: SHOW_RELOGIN_DIALOG,
});

export const setReloginDialogLoading = () => ({
  type: SET_RELOGIN_DIALOG_LOADING,
});

export const setReloginDialogLoaded = () => ({
  type: SET_RELOGIN_DIALOG_LOADED,
});
